import type { RouteObject } from 'react-router';
import { onboardingRoutePatterns } from '@/onboarding/constants/routes';

export const onboardingRouteChildren: RouteObject[] = [
  {
    path: onboardingRoutePatterns.createProfile,
    lazy: () =>
      import('@/onboarding/pages/create-profile-page').then((m) => ({
        Component: m.CreateProfilePage,
      })),
  },
];
